function showWordTest(fromIndex, toIndex) {

    console.log('showWords from', fromIndex, ' to ', toIndex);

    if (toIndex === undefined) {
      toIndex = fromIndex - 1;
      fromIndex = 0;
    }

    var n = toIndex - fromIndex + 1;
    var minTop = halfCanvasHeight - wordHeight / 2 - wordBorder;
    var responseType = listArrays[allColumns.indexOf('responseType')][trialRow];

    if ((listNoStim[trialRow] > 1 || listNoStimS2[trialRow] > 1) && (listArrays[allColumns.indexOf('type')][trialRow]=="test" || listArrays[allColumns.indexOf('type')][trialRow]=="practice") && listArrays[allColumns.indexOf('keyboard')][trialRow]=="na" && listArrays[allColumns.indexOf('button1')][trialRow]=="na" && listArrays[allColumns.indexOf('responseType')][trialRow] == 'na')//if responses are recorded via keyboard or buttons
    {
        responseType = 'clicks';
    }

    //set vertical alignment
    for (var i = 1; i < n + 1; i++) {
        var key = "word" + i;
        var stimContainerIndex = i + fromIndex;
        stimContainers[stimContainerIndex].style.top = (halfCanvasHeight - wordHeight / 2 - wordBorder) + "px";
        if (responseType != 'clicks') {
            stimContainers[stimContainerIndex].style.border = "transparent";
            stimContainers[stimContainerIndex].style.background = "transparent";
            stimContainers[stimContainerIndex].style.cursor = null;
        } else {
            stimContainers[stimContainerIndex].style.border = null; //revert to property defined under class (because sometimes it's changed)
            stimContainers[stimContainerIndex].style.background = null;
            stimContainers[stimContainerIndex].style.cursor = "pointer";
        }
        
        stimContainers[stimContainerIndex].style.cursor = getCursorForCurrentTrial();
          
    };
    //set horizontal alignment

    canvasWidth = $('#displayScreen').width();
    canvasHeight = $('#displayScreen').height();

    if(columnForTrial('stimPos', trialRow) === 'na') {
    switch (n) {
        case 1:
            stimContainers[fromIndex + 1].style.width = width1word + "px";
            stimContainers[fromIndex + 1].style.top = (canvasHeight / 2 - wordHeight / 2 - wordBorder) + "px"; //for some reason no border correction needed here (when border is transparent)
            stimContainers[fromIndex + 1].style.left = (canvasWidth / 2 - width1word / 2 - wordBorder) + "px"; //for some reason no border correction needed here (when border is transparent)
            break;

        case 2:
            stimContainers[fromIndex + 1].style.width = width2words + "px";
            stimContainers[fromIndex + 1].style.left = (canvasWidth / 2 - space2words / 2 - width2words - wordBorder) + "px";

            stimContainers[fromIndex + 2].style.width = width2words + "px";
            stimContainers[fromIndex + 2].style.left = (canvasWidth / 2 + space2words / 2 - wordBorder) + "px";
            break;

        case 3:
            stimContainers[fromIndex + 1].style.width = width3words + "px";
            stimContainers[fromIndex + 1].style.left = (canvasWidth / 2 - 3 * width3words / 2 - space3words - wordBorder) + "px";

            stimContainers[fromIndex + 2].style.width = width3words + "px";
            stimContainers[fromIndex + 2].style.left = (canvasWidth / 2 - width3words / 2 - wordBorder) + "px";

            stimContainers[fromIndex + 3].style.width = width3words + "px";
            stimContainers[fromIndex + 3].style.left = (canvasWidth / 2 + width3words / 2 + space3words - wordBorder) + "px";
            break;

        case 4:
            stimContainers[fromIndex + 1].style.width = width4words + "px";
            stimContainers[fromIndex + 1].style.left = (canvasWidth / 2 - 2 * width4words - 3 * space4words / 2 - wordBorder) + "px";

            stimContainers[fromIndex + 2].style.width = width4words + "px";
            stimContainers[fromIndex + 2].style.left = (canvasWidth / 2 - width4words - space4words / 2 - wordBorder) + "px";

            stimContainers[fromIndex + 3].style.width = width4words + "px";
            stimContainers[fromIndex + 3].style.left = (canvasWidth / 2 + space4words / 2 - wordBorder) + "px";

            stimContainers[fromIndex + 4].style.width = width4words + "px";
            stimContainers[fromIndex + 4].style.left = (canvasWidth / 2 + width4words + 3 * space4words / 2 - wordBorder) + "px";
            break;

        case 5:
            stimContainers[fromIndex + 1].style.width = width5words + "px";
            stimContainers[fromIndex + 1].style.left = (canvasWidth / 2 - 5 * width5words / 2 - 2 * space5words - wordBorder) + "px";

            stimContainers[fromIndex + 2].style.width = width5words + "px";
            stimContainers[fromIndex + 2].style.left = (canvasWidth / 2 - 3 * width5words / 2 - space5words - wordBorder) + "px";

            stimContainers[fromIndex + 3].style.width = width5words + "px";
            stimContainers[fromIndex + 3].style.left = (canvasWidth / 2 - width5words / 2 - wordBorder) + "px";

            stimContainers[fromIndex + 4].style.width = width5words + "px";
            stimContainers[fromIndex + 4].style.left = (canvasWidth / 2 + width5words / 2 + space5words - wordBorder) + "px";

            stimContainers[fromIndex + 5].style.width = width5words + "px";
            stimContainers[fromIndex + 5].style.left = (canvasWidth / 2 + 3 * width5words / 2 + 2 * space5words - wordBorder) + "px";
            break;

        case 6:
            stimContainers[fromIndex + 1].style.width = width6words + "px";
            stimContainers[fromIndex + 1].style.left = (canvasWidth / 2 - 3 * width6words - 5 * space6words / 2 - wordBorder) + "px";

            stimContainers[fromIndex + 2].style.width = width6words + "px";
            stimContainers[fromIndex + 2].style.left = (canvasWidth / 2 - 2 * width6words - 3 * space6words / 2 - wordBorder) + "px";

            stimContainers[fromIndex + 3].style.width = width6words + "px";
            stimContainers[fromIndex + 3].style.left = (canvasWidth / 2 - width6words - space6words / 2 - wordBorder) + "px";

            stimContainers[fromIndex + 4].style.width = width6words + "px";
            stimContainers[fromIndex + 4].style.left = (canvasWidth / 2 + space6words / 2 - wordBorder) + "px";

            stimContainers[fromIndex + 5].style.width = width6words + "px";
            stimContainers[fromIndex + 5].style.left = (canvasWidth / 2 + width6words + 3 * space6words / 2 - wordBorder) + "px";

            stimContainers[fromIndex + 6].style.width = width6words + "px";
            stimContainers[fromIndex + 6].style.left = (canvasWidth / 2 + 2 * width6words + 5 * space6words / 2 - wordBorder) + "px";
            break;
        default:
            var widthNwords = adjuster * 100;
            var spaceNwords = adjuster * 30;
            var widthNwords = adjuster * 130;
        
                
            for(var i = 1; i <= n; i++){
                var left = false;
                var currentLeftPos = canvasWidth / 2 - wordBorder;
                var countLeft = 0;
                var countRight = 0;
                if(i < n/2){
                    left = true;
                    countLeft = Math.ceil(n/2) - i;
                }
                else{
                    countRight = i - Math.ceil(n/2);
                }
        
                if(left){
                    currentLeftPos = currentLeftPos - countLeft * widthNwords - countLeft * spaceNwords;
                }
                else{
                    currentLeftPos = currentLeftPos + countRight * widthNwords + countRight * spaceNwords;
                }
                
                if(n%2 == 0){
                    currentLeftPos -= widthNwords/2;
                }
        
                stimContainers[i + fromIndex].style.left = currentLeftPos - widthNwords/2 + "px";
            }

    }
    for (var i = 1; i < n + 1; i++) {
        stimContainers[i + fromIndex].style.display = "block";
    };
    }
    else{
        for (let stimIndex = fromIndex + 1; stimIndex <= toIndex + 1; stimIndex++) {
            stimContainers[stimIndex].style.width = "";
            stimContainers[stimIndex].style.visibility = "hidden";
            stimContainers[stimIndex].style.display = "block";
            const stimPos = computeWordPosition(stimIndex);
            
            if (stimPos.top < minTop) {
                minTop = stimPos.top;
            }

            if (stimPos.top > window.maxTrialAllImagesTop) {
                window.maxTrialAllImagesTop = stimPos.top;
            }
            stimContainers[stimIndex].style.left = stimPos.left + "px";
            stimContainers[stimIndex].style.top = stimPos.top + "px";
            stimContainers[stimIndex].style.visibility = "";
        }
    }
    if (isLongWordTrial(window.trialRow)) {
        minTop = positionLongWords(fromIndex, n);
    }

    window.screenViewStart = performance.now();

    window.minTrialAllImagesTop = minTop;
    return minTop;
}

function computeWordPosition(index) {
    const currentWordBounds = stimContainers[index].getBoundingClientRect();
    const currentPos = {
        left: canvasWidth / 2 - currentWordBounds.width / 2 + stimPosList[index - 1].horizontal,
        top: canvasHeight / 2 - currentWordBounds.height / 2 + stimPosList[index - 1].vertical
    }
    
    return currentPos;
}